import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Rating,
    Box,
    Typography
} from "@mui/material";

const CourseFeedbackDialog = ({
    open,
    onClose,
    onSubmit,
    courseName
}) => {
    const [rating, setRating] = useState(0);

    const handleSubmit = () => {
        onSubmit({ rating });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Rate this course</DialogTitle>

            <DialogContent>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                >
                    <Typography>
                        How would you rate <strong>{courseName}</strong>?
                    </Typography>

                    <Rating
                        value={rating}
                        onChange={(e, newValue) => setRating(newValue)}
                        size="large"
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!rating}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CourseFeedbackDialog;